<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <el-input class="input-v2 prefix-primary-color" placeholder="姓名" suffix-icon="el-icon-search" v-model="queryParams.empName"></el-input>&nbsp;&nbsp;&nbsp;
        <el-button type="primary" class="button-v2" @click="getData">查询</el-button>
      </div>
      <div class="title-right">
        <!--<el-button type="primary" class="button-v2" @click="addUpload=true">新增</el-button>-->
        <el-button type="primary" class="button-v2" @click="exportExcel">导出</el-button>
        <el-button plain class="button-v2" @click="goBack">返回</el-button>
      </div>
    </div>
    <div class="pl24 pr24 pt24" style="font-size: 14px">
      <div>年-月/批次号：{{importDate.substring(0,7)}}/{{branchId}}</div>
    </div>
    <div class="table-body flex vertical" style="height: calc(100vh - 234px);">
      <air-table
        ref="airTable"
        class="table-v2"
        align="center"
        :columns="columns"
        :data="tableData"
        @checkbox-change="handleSelectionChange"
        @checkbox-all="handleSelectionChange"
        @change-filter="changeFilter"
        :showOperation="false"
        :show-checkbox="false"
      >
        <template #operation="{ row }">
          <div class="flex center">
            <span v-if="false" class="text-button" @click="handleUpdate(row)">编辑</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="pageChange" @page-size-change="pageSizeChange" show-page-size />
    </div>
    <!-- 新增弹框 -->
    <el-dialog
      class="modal-v2 has-padding"
      ref="cusPaysetDialog"
      v-dialogDrag
      :title="addUploadTitle"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addUpload"
      v-loading="loading"
      append-to-body
      width="700px"
    >
      <el-form class="form-v2" ref="details" :model="details" label-width="100px">
        <template v-for="(child, childIndex) in columns">
          <el-form-item :label="`${child.title}：`" :prop="child.field">
            <el-input v-model="details[child.field]" class="input-v2" placeholder="请输入" maxlength="20" />
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button class="button-v2" plain @click="addUpload = false">取消</el-button>
        <el-button class="button-v2" type="primary" @click="_updateDetail">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {getLoadBatchData,exportExcle,updateDetail} from "@/api/merit/ruichen.js"
  import {downloadFile} from "@/util/util";
  import { validatenull } from '@/util/validate';
  
  export default {
    name: 'MeritDetails',
    created() {
      this.getData()
    },
    data() {
      return {
        branchId:this.$route.query.batchId,
        importDate:this.$route.query.importDate,
        queryParams: {
          empName:'',
          page: 1,
          limit: 20,
          total: 0
        },
        change:'1',
        addUpload: false,
        addUploadTitle:'添加雇员绩效信息',
        
        columns: [],
        tableData: [],
        multipleSelection: [],
        details:{}
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.queryParams.page = 1;
        }
        this.getData();
      },
      // 分页输入框回车，调接口
      pageSizeChange(val) {
        this.queryParams = Object.assign(val);
        this.getData();
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData};
        this.getData();
      },
      handleSelectionChange({records}) {
        this.multipleSelection = records;
      },
      
      // 初始化数据
      getData() {
        let params = {
            pageNum: '2',
            ...this.queryParams,
            batchId:this.$route.query.batchId
        }
        getLoadBatchData(params).then(res=>{
          this.tableData = res.data.records
          this.columns = res.data.condition.columns
          this.queryParams.total = parseInt(res.data.total)
        })
      },
      handleUpdate(row){
        this.details=row;
        this.addUpload=true;
        this.addUploadTitle='添加雇员绩效信息';
      },
      // 修改
      _updateDetail() {
        updateDetail(this.details).then(res=>{
        
        })
      },
      // 导出
      exportExcel() {
        exportExcle(this.$route.query.batchId).then(res=> {
          downloadFile(res)
        })
      }
    }
  }
</script>
